var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDHeatingRoomBalancingValves = function SvgDHeatingRoomBalancingValves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 322.96,
    y: 136,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "327.94 150 319.96 164 335.95 163.99 327.94 150",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.94,152.02l6.29,10.97h-12.55s6.26-10.97,6.26-10.97M327.94,150l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "327.94 150 319.96 136.01 335.95 136 327.94 150",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.23,137l-6.29,10.98-6.26-10.98h12.55M335.95,136h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "338.36 156.17 323.72 146.59 324.4 145.55 318 143.45 322.49 148.47 323.17 147.42 337.82 157 338.36 156.17",
    fill: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 516.96,
    y: 136,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "521.94 150 513.96 164 529.95 163.99 521.94 150",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.94,152.02l6.29,10.97h-12.55s6.26-10.97,6.26-10.97M521.94,150l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "521.94 150 513.96 136.01 529.95 136 521.94 150",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.23,137l-6.29,10.98-6.26-10.98h12.55M529.95,136h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "532.36 156.17 517.72 146.59 518.4 145.55 512 143.45 516.49 148.47 517.17 147.42 531.82 157 532.36 156.17",
    fill: "#1d1d1b"
  })))));
};
export default SvgDHeatingRoomBalancingValves;